import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/role`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ptl/role/role-mgmt`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0104015q: `${BASE.path}/osci0104015q`, // List of roles                           !== 역할 관리 목록 ==!
    osci0104016s: `${BASE.path}/osci0104016s`, // Register for Role Management            !== 역할 관리 등록 ==!
    osci0104017s: `${BASE.path}/osci0104017s`, // Modifying and deleting role management  !== 역할 관리 수정 및 삭제 ==!
};

export const PGEUIDS = {
    osci0104015q: "osci0104015q",
    osci0104016s: "osci0104016s",
    osci0104017s: "osci0104017s",
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Select Role Management List  !== 역할 목록 조회 ==!
    getRoleList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) });
    },
    // Select Role Management Detail  !== 역할 정보 조회 ==!
    getRoleDtl: (data: any) =>
        api.get(`${BASE.api}/${data.roleId}`, { params: comnUtils.toGetParams({ ptlTpCd: data.ptlTpCd }) }),
    // Create Role Management Detail  !== 역할 정보 등록 ==!
    createRoleDtl: (data: any) => api.post(`${BASE.api}`, { ...data }),
    // Modify Role Management Detail  !== 역할 정보 수정 ==!
    updateRoleDtl: (data: any) => api.put(`${BASE.api}/${data.roleId}`, { ...data }),
    // Deleate Role Management Detail  !== 역할 정보 삭제 ==!
    deleteRoleDtl: (data: any) =>
        api.delete(`${BASE.api}/${data.roleId}`, { params: comnUtils.toGetParams({ ptlTpCd: data.ptlTpCd }) }),

    // Select Role user mapping !== 역할 사용자 매핑 여부 ==!
    getRoleMapInfo: (roleId: any) => api.get(`${BASE.api}/map`, { params: comnUtils.toGetParams({ roleId: roleId }) }),
};

export const SF_ROLE_MGMT_SRCH: TFormSchema = {
    id: "form_roleMgmtSrch",
    schema: {
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "E", "O"],
        },
        roleId: { type: "code", label: "L_ROLE_ID", area: "roleCd" },
    },
};

export const SF_ROLE_MGMT_DTL: TFormSchema = {
    id: "form_roleMgmtInfo",
    schema: {
        roleId: { type: "text", label: "L_ROLE_ID", required: true, edit: false },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B"],
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            viewType: "label",
            options: [
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
            ],
            required: true,
        },
        roleNmKO: { type: "text", label: "L_ROLE_NM_KO", required: true, maxLength: 50 },
        roleNmEN: { type: "text", label: "L_ROLE_NM_EN", required: true, maxLength: 50 },
        roleNmTZ: { type: "text", label: "L_ROLE_NM_TZ", required: true, maxLength: 50 },
        roleDescKO: { type: "text", label: "L_ROLE_DESC_KO", maxLength: 150 },
        roleDescEN: { type: "text", label: "L_ROLE_DESC_EN", maxLength: 150 },
        roleDescTZ: { type: "text", label: "L_ROLE_DESC_TZ", maxLength: 150 },
    },
};

export const SG_ROLE_MGMT_LIST: TGridSchema = {
    id: "grid_roleMgmtList",
    options: { pagination: "out", edit: false, index: true },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "10%" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "8%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "12.5%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "8%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "12.5%" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: "2.2%" }] },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCd", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId", edit: false }] },
        { cells: [{ binding: "roleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "roleDesc", edit: false, align: "left" }] },
        { cells: [{ binding: "frstRegstId", edit: false }] },
        { cells: [{ binding: "frstRgsrDtm", edit: false }] },
        { cells: [{ binding: "lastMdfrId", edit: false }] },
        { cells: [{ binding: "lastMdfyDtm", edit: false }] },
        { cells: [{ binding: "useYn", edit: false }] },
        { cells: [{ binding: "ptlTpCd" }] },
    ],
};

export const SG_ROLE_LANG_LIST: TGridSchema = {
    id: "grid_roleLangList",
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_LANG_CD", binding: "langCd", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCd", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId" }] },
        { cells: [{ binding: "langCd" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "left" }] },
        { cells: [{ binding: "ptlTpCd" }] },
    ],
};
